<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Kommunal xidmətlər</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <h2>"Azərişıq" ASC tərəfindən göstərilən xidmətlərin tarifləri.</h2>
        <p class="note">
          Azərbaycan Respublikası Tarif (qiymət) Şurasının 2024-cü il 29 dekabr
          tarixli 19 nömrəli Qərarına əsasən:<br />
          - aylıq istehlak həcminin 200 kVts-a qədər (200 kVts daxil) olan
          hissəsi üçün 0.084 AZN, <br />
          - aylıq istehlak həcminin 200 kVts-dan 300 kVts-a qədər (300 kVts
          daxil) olan hissəsi üçün 0.10 AZN,<br />
          - aylıq istehlak həcminin 300 kVts-dan çox olan hissəsi üçün 0.15 AZN
          hesablanır.
        </p>
      </div>
      <div class="col-md-6">
        <p>Aylıq elektrik enerji sərfiyyatı (kVts):</p>
        <input type="number" v-model="light" />
      </div>
      <div class="col-md-6">
        <p>Aylıq ödəniləcək məbləğ:</p>
        <input type="text" v-model="calcLight" disabled />
      </div>
    </div>

    <br /><br />

    <div class="row">
      <div class="col-12">
        <h2>
          SOCAR-ın "Azəriqaz" İstehsalat Birliyi tərəfindən göstərilən
          xidmətlərin tarifləri.
        </h2>
        <p class="note">
          Azərbaycan Respublikası Tarif (qiymət) Şurasının 2024-cü il 29 dekabr
          tarixli 13 nömrəli Qərarına əsasən,<br />
          - illik istehlak həcminin 1200 m<sup>3</sup>-dək (1200 m<sup>3</sup>
          daxil) olan hissəsi üçün - 0.125 AZN / m<sup>3</sup>,<br />
          - illik istehlak həcminin 1200 - 2500 <sup>3</sup> olan hissəsi üçün -
          0.22 AZN / m<sup>3</sup>,<br />
          - illik istehlak həcminin 2500 m<sup>3</sup>-dən çox olan hissəsi üçün
          isə 0.30 AZN / m<sup>3</sup> hesablanır.
        </p>
      </div>
      <div class="col-md-6">
        <p>İllik təbii qaz sərfiyyatı (m<sup>3</sup>):</p>
        <input type="number" v-model="gas" />
      </div>
      <div class="col-md-6">
        <p>İllik ödəniləcək məbləğ:</p>
        <input type="text" v-model="calcGas" disabled />
      </div>
    </div>

    <br /><br />

    <div class="row">
      <div class="col-12">
        <h2>
          “Azərsu” ASC tərəfindən həyata keçirilən su təchizatı və tullantı
          sularının axıdılması xidmətlərinin tarifləri.
        </h2>
        <p class="note">
          Azərbaycan Respublikası Tarif (qiymət) Şurasının 2021-ci il 30 yanvar
          tarixli 5 nömrəli Qərarına əsasən Bakı şəhərində 1 m<sup>3</sup> su
          təchizatı üçün - 0.70 AZN, 1 m<sup>3</sup> tullantı suları üçün isə
          0.30 AZN hesablanır.
        </p>
      </div>
      <div class="col-md-6">
        <p>Aylıq su sərfiyyatı (m<sup>3</sup>):</p>
        <input type="number" v-model="water" />
      </div>
      <div class="col-md-3">
        <p>Su təchizatı:</p>
        <input type="text" v-model="calcWater" disabled />
      </div>
      <div class="col-md-3">
        <p>Tullantı suları:</p>
        <input type="text" v-model="calcSewage" disabled />
      </div>
    </div>

    <br /><br />

    <div class="row">
      <div class="col-12">
        <h2>
          “Azəristiliktəchizat” ASC tərəfindən göstərilən xidmətlərin tarifləri.
        </h2>
        <p class="note">
          Azərbaycan Respublikası Tarif (qiymət) Şurasının 29 dekabr 2024-cü il
          tarixli 17 nömrəli Qərarına əsasən mərkəzi isitmə 1 m<sup>2</sup>
          yaşayış sahəsi üçün aylıq 0.30 AZN hesablanır.
        </p>
      </div>
      <div class="col-md-6">
        <p>Mənzilinizin yaşayış sahəsi (m<sup>2</sup>):</p>
        <input type="number" v-model="heat" />
      </div>
      <div class="col-md-6">
        <p>Aylıq ödəniləcək məbləğ:</p>
        <input type="text" v-model="calcHeat" disabled />
      </div>
    </div>

    <br /><br />

    <div class="row">
      <div class="col-12">
        <h2>Mənzil haqqı və mənzil-kommunal xidmətlərinə görə tarifləri.</h2>
        <p class="note">
          Azərbaycan Respublikası Nazirlər Kabinetinin 2000-ci il 10 mart
          tarixli, 40 nömrəli qərarına əsasən tam kommunal təminatlı mənzillər
          üzrə 1 kv.m. yaşayış sahəsi üçün 1 ayda - 0.02 AZN hesablanır.
        </p>
      </div>
      <div class="col-md-6">
        <p>Mənzilinizin yaşayış sahəsi (m2):</p>
        <input type="number" v-model="mkis" />
      </div>
      <div class="col-md-6">
        <p>Aylıq ödəniləcək məbləğ:</p>
        <input type="text" v-model="calcMkis" disabled />
      </div>
    </div>

    <br /><br />

    <div class="row">
      <div class="col-12">
        <h2>
          Məişət tullantılarının yığılması və daşınması xidmətlərinin tarifləri.
        </h2>
        <p class="note">
          Azərbaycan Respublikası Tarif (qiymət) Şurasının 29 iyun 2024-cü il
          tarixli 8 nömrəli Qərarına əsasən əhali üçün tariflər aşağıdakı kimi
          müəyyən edilib:
        </p>
        <table>
          <tbody>
            <tr>
              <td>Bərk məişət tullantılarının yığılması və daşınması</td>
              <td>1 nəfər - 1 manat</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <br /><br />

    <div class="row">
      <div class="col-12">
        <h2>Fiziki şəxslərin əmlak vergisi (bələdiyyə).</h2>
        <p class="note">
          Fiziki şəxslərin xüsusi mülkiyyətində olan binaların sahəsinin
          (yaşayış sahələrinə münasibətdə - onların 30 kv.metrdən artıq olan
          hissəsinin) hər kv.metrinə görə dərəcələr tətbiq olunur. Bakı
          şəhərində yerləşən binalara münasibətdə, həmin dərəcələrə Azərbaycan
          Respublikası Nazirlər Kabinetinin “Azərbaycan Respublikası Vergi
          Məcəlləsinin 198.1.1-ci maddəsində nəzərdə tutulmuş fiziki şəxslərin
          əmlak vergisi məqsədləri üçün Bakı şəhərində yerləşən binalara tətbiq
          edilən əmsallar”ın təsdiq edilməsi barədə 2015-ci il 6 aprel tarixli
          101 nömrəli Qərarı ilə müəyyən olunmuş 0,7 - 1,5 hədlərində əmsallar
          tətbiq edilir.
        </p>
      </div>
      <div class="col-md-4">
        <p>Mənzilinizin ümumi sahəsi (m<sup>2</sup>):</p>
        <input type="number" v-model="emlak" />
      </div>
      <div class="col-md-4">
        <p>Binanın yerləşdiyi zona:</p>
        <select v-model="bakuzone">
          <option value="1.50">zona 1</option>
          <option value="1.40">zona 2</option>
          <option value="1.30">zona 3</option>
          <option value="1.20">zona 4</option>
          <option value="1.10">zona 5</option>
          <option value="1.00">zona 6</option>
          <option value="0.95">zona 7</option>
          <option value="0.90">zona 8</option>
          <option value="0.85">zona 9</option>
          <option value="0.80">zona 10</option>
          <option value="0.75">zona 11</option>
          <option value="0.70">zona 12</option>
        </select>
      </div>
      <div class="col-md-4">
        <p>İllik ödəniləcək məbləğ:</p>
        <input type="text" v-model="calcEmlak" disabled />
      </div>
      <div class="col-12">
        <p class="note">
          Bakı şəhəri üzrə müəyyən edilən zonalar və onların sərhədləri haqqında
          məlumatı
          <a href="http://www.e-qanun.az/framework/29860" target="_blank"
            >buradan</a
          >
          öyrənə bilərsiniz.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      light: "",
      gas: "",
      water: "",
      heat: "",
      emlak: "",
      mkis: "",
      bakuzone: "",
    };
  },
  computed: {
    calcLight() {
      if (this.light <= 200) {
        return (this.light * 0.084).toFixed(2) + " AZN";
      }
      if (this.light <= 300) {
        return (200 * 0.084 + (this.light - 200) * 0.1).toFixed(2) + " AZN";
      }
      if (this.light > 300) {
        console.log("this.light - 200:", this.light - 200);
        return (
          (200 * 0.084 + 100 * 0.1 + (this.light - 300) * 0.15).toFixed(2) +
          " AZN"
        );
      }
    },
    calcGas() {
      if (this.gas <= 1200) {
        return (this.gas * 0.125).toFixed(2) + " AZN";
      } else if (this.gas <= 2500) {
        return (1200 * 0.125 + (this.gas - 1200) * 0.22).toFixed(2) + " AZN";
      } else if (this.gas > 2500) {
        return (
          (1200 * 0.125 + 1300 * 0.22 + (this.gas - 2500) * 0.3).toFixed(2) +
          " AZN"
        );
      }
    },
    calcWater() {
      return (this.water * 0.7).toFixed(2) + " AZN";
    },
    calcSewage() {
      return (this.water * 0.3).toFixed(2) + " AZN";
    },
    calcHeat() {
      return (this.heat * 0.3).toFixed(2) + " AZN";
    },
    calcMkis() {
      return (this.mkis * 0.02).toFixed(2) + " AZN";
    },
    calcEmlak() {
      if (this.emlak < 30) {
        return "0.00 AZN";
      } else {
        return ((this.emlak - 30) * 0.4 * this.bakuzone).toFixed(2) + " AZN";
      }
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/calc/Communal.vue